import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=dc5f4798&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=dc5f4798&lang=scss&scoped=true"
import style1 from "./preview.vue?vue&type=style&index=1&id=dc5f4798&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5f4798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc5f4798')) {
      api.createRecord('dc5f4798', component.options)
    } else {
      api.reload('dc5f4798', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=dc5f4798&scoped=true", function () {
      api.rerender('dc5f4798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/noticeContent/components/preview.vue"
export default component.exports